import type { AxiosResponse } from 'axios'
import axios from 'axios'
import type { DateTime } from 'luxon'

import environment from '@/environment'

export const PRODUCTION_PLANS_API_URL = environment.services.productionPlanApiUrl

/**
 * Calls backend endpoint to export production plan CSV for the given date.
 *
 * @param date - Desired production plan date. The backend expects an ISO date string (yyyy-MM-dd).
 * @returns Object containing the CSV Blob and the filename parsed from the Content-Disposition header (if present).
 */
export async function exportProductionPlan(date: DateTime): Promise<{ blob: Blob; filename?: string }> {
  const dateString = date.toISODate() // yyyy-MM-dd
  const url = `${PRODUCTION_PLANS_API_URL}/export`

  const response = await axios.post<Blob>(url, undefined, {
    params: { date: dateString },
    responseType: 'blob',
    headers: {
      Accept: 'text/csv',
    },
  })

  const filename = parseFilename(response)
  return { blob: response.data, filename }
}

function parseFilename(response: AxiosResponse): string | undefined {
  const contentDisposition = response.headers['content-disposition'] as string | undefined
  let filename: string | undefined

  if (contentDisposition) {
    const parts = contentDisposition.split('filename=')
    if (parts.length > 1) {
      const after = parts[1]
      const raw = after.split(';')[0].trim()
      filename = raw.replace(/^"(.*)"$/, '$1')
    }
  }

  return filename
}
